import React from 'react';

import { Link, Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { CONTACT_SUPPORT } from '../constants/urls';
import error500 from '../images/500.svg';

const StyledErrorContainer = styled.div`
    text-align: center;
`;

const StyledErrorMessage = withStyles(() => ({
    root: {
        textAlign: 'center'
    }
}))(Typography);

interface Error500Props {
    errorMessage?: string;
    errorData?: string;
}

const Error500 = (props : Error500Props) => {
    const { errorMessage, errorData } = props;
    const { t } = useTranslation('error_messages');
    return (
        <StyledErrorContainer>
            <StyledErrorMessage variant="h4">{t('error_messages:have-a-problem')}</StyledErrorMessage>
            <img src={error500}></img>
            <StyledErrorMessage variant="h4">
                <Link href={CONTACT_SUPPORT} target="_blank">
                    {t('error_messages:contact-support')}
                </Link>
            </StyledErrorMessage>
            <StyledErrorMessage variant="h5">{errorMessage ?? ''}</StyledErrorMessage>
            <StyledErrorMessage variant="h5">{errorData ?? ''}</StyledErrorMessage>
        </StyledErrorContainer>
    );
};

export default Error500;
